export default __webpack_public_path__ + "static/etna-97bbef6f698395ee8e72eb7b100b8144.jpg";